/**
 * Writes text to the user's clipboard. Silently warns on failure or missing API.
 *
 * @param text - The text content to copy to the clipboard.
 */
export const copyToClipboard = async (text: string): Promise<void> => {
  if (!navigator.clipboard) {
    console.warn('Clipboard API not available');
    return;
  }

  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.warn('Failed to copy text to clipboard', error);
  }
};
